import * as d3 from 'd3-selection'

var getY = function (menu, control, data) {
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    , top = control.top + control.height + scrollTop
    , after = window.innerHeight - control.top - control.height

  if (!data.forceMenuBelow && (after < menu.node().offsetHeight && control.top > after)) {
    // The menu doesn't have enough space, and we have more space above than below,
    // so position the menu above the control
    return {
      bottom: (window.innerHeight - (top - control.height)) + 'px',
      top: null
    }
  } else {
    return {
      top: top + 'px',
      bottom: null
    }
  }
}

var getX = function (menu, control, isRtl) {
  var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
    , width = menu.node().offsetWidth
    , menuPosition = {}

  if (isRtl) {
    let right = window.innerWidth - control.right + scrollLeft
    menuPosition.left = 'auto'
    menuPosition.right = right + 'px'
  } else {
    let left = control.left + scrollLeft
    if (control.left + width > window.innerWidth) {
      // Right of menu is outside of window
      let rightAligned = control.right - width
      if (rightAligned > 0) {
        // we can right align
        left = rightAligned + scrollLeft
        menuPosition.alignment = 'menu-right-align'
      }
    }
    menuPosition.right = 'auto'
    menuPosition.left = left + 'px'
  }

  return menuPosition
}

export default function (selection, control, isRtl) {
  selection.each(function (data) {
    var menu = d3.select(this)

    // Only when we have a menu
    menu.each(function () {
      if (data.fullHeight) {
        // Clear the previous max height set so positioning code (i.e. `getY`) can determine actual heights
        menu.select('.select-menu-results').style('max-height', 'none')
      }
      var y = getY(menu, control, data)
        , x = getX(menu, control, isRtl)

      menu.style('left', x.left)
        .style('right', x.right)

      for (const [key, value] of Object.entries(y)) {
        menu.style(key, value)
      }

      menu.classed('menu-right-align', x.alignment === 'menu-right-align')
          .classed('menu-above', y.top === null)
          .classed('menu-below', y.bottom === null)

      if (data.fullHeight) {
        // When this option is set, we want the menu to take up as much space as it needs, without
        // exceeding the browser boundaries
        var offset = 49 // 20px + the 29 height set in css. Hardcoded b/c for some reason when opening the menu the browser can return some larger number. See SB3 #18792
          , height = y.top === null ? control.top - offset
                                    : window.innerHeight - control.bottom - offset

        menu.select('.select-menu-results')
            .style('max-height', Math.max(offset, height) + 'px')
      }
    })
  })
}
